module.exports = __webpack_public_path__ + "img/icon-rights-warn.2ebb8211.svg";